import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 20FEED41-F560-4872-82F4-4ED5D01EA474
 * name folder-download-outline
 * version: 4.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/folder-download-outline.svg
 * tags
 * - Files / Folders 
 */
export const FolderDownloadOutlineIcon = createSvgIcon(<><path d="M20 18H4V8H20M20 6H12L10 4H4A2 2 0 0 0 2 6V18A2 2 0 0 0 4 20H20A2 2 0 0 0 22 18V8A2 2 0 0 0 20 6M14 9H16V13H19L15 17L11 13H14Z" /></>, 'FolderDownloadOutlineIcon');
export default FolderDownloadOutlineIcon